// extracted by mini-css-extract-plugin
export var numpadContainer = "_ko-1";
export var phoneButton = "_ko-0";